import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const createDepartmentStart = createAction(
  'CREATE_DEPARTMENT::START',
  withPayloadType<{ departmentName: string; organizationId: string }>(),
);
